<template>
  <tr>
    <td><span v-if="!isLimit">#</span></td>
    <td>
      <select-project
        v-if="!isLimit"
        class="pt-0 mt-0"
        v-model="value.entity_id"
        :items="projectList"
        :rules="[v => !!v || 'Project is required']"
        label=""
        required
        :default-value="false"
        hide-details
      />
    </td>
    <td>
      <v-combobox
        v-if="!isLimit"
        class="pt-0 mt-0"
        v-model="value.level"
        :items="value.entity_id in maxLvlByProject ? maxLvlToVSelectItems(maxLvlByProject[value.entity_id]) : levels"
        hide-details
      />
    </td>
    <td>
      <v-select
        v-if="!isLimit"
        class="pt-0 mt-0"
        v-model="value.currency"
        :items="$store.state.auth.currencies"
        :rules="[v => !!v || 'Currency is required']"
        required
        hide-details
      />
    </td>
    <td>
      <select-countries
        style="max-width: none"
        v-if="isLimit"
        :isShowSelectedItemIcon="true"
        :staticCountries="true"
        :chosenCountries="country"
        @input="editCountry"
        :countries="allCountries"
        :multiple="false"
        :class="['mb-1', { 'country-duplicate-error': isCountryDuplicate }]"
      >
      </select-countries>
      <div v-else>Default</div>
    </td>
    <td>
      <v-text-field
        class="pt-0 mt-0"
        v-model="value.limits[country].min"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        class="pt-0 mt-0"
        v-model="value.limits[country].max"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        class="pt-0 mt-0"
        v-model="value.limits[country].max_per_day"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        class="pt-0 mt-0"
        v-model="value.limits[country].max_per_week"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        class="pt-0 mt-0"
        v-model="value.limits[country].max_per_month"
        hide-details
      />
    </td>
    <td>
      <slot name="action" v-bind:item.sync="value"></slot>
    </td>
  </tr>
</template>

<style>
  .country-duplicate-error {
    border: 2px solid #f44336 !important;
    border-radius: 4px;
  }
</style>


<script>
  import { isNumber, map } from 'lodash'
  import { allCountries } from '@/components/core/SelectLang/mapperIsoLocale'
  import SelectCountries from '@/components/core/SelectCountries.vue'
  import LangCircle from '@/components/core/SelectLang/LangRow/LangCircle.vue'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  const TEXT_LVLS = ['default', 'vip']
  const DEFAULT_LVLS = [...TEXT_LVLS, 1, 2, 3, 4, 5, 6]

  export default {
    components: { LangCircle, SelectCountries, SelectProject },
    props: {
      value: { default: {} },
      isLimit: {
        type: Boolean,
        default: false
      },
      country: {
        type: String,
        default: 'default'
      },
      maxLvlByProject: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      allCountries,
      levels: DEFAULT_LVLS,
      isCountryDuplicate: false,
    }),

    mounted () {
      if (!this.value.entity_id) {
        this.$emit('input', { key: 'entity_id', value: this.projectList[0]?.value })
      }

      if (!this.value.currency) {
        this.$emit('input', { key: 'currency', value: 'EUR' })
      }

      if (!this.value.level) {
        this.$emit('input', { key: 'level', value: 'default' })
      }
    },

    watch: {
      'value.level': function (n, o) {
        if (parseInt(n) == n) n = parseInt(n)

        if (!this.levels.includes(n) && !isNumber(n)) {
          this.$nextTick(function () {
            this.$set(this.value, 'level', o)
          })
        }
      },
      value: {
        handler (newValue, oldValue) {
          return newValue
        },
        deep: true,
      },
      'value.limits': {
        handler () {
          this.$nextTick(() => {
            this.recalculateValidation()
          })
        },
        deep: true
      }
    },

    computed: {
      projectList: function () {
        return map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      },
    },

    methods: {
      editCountry (country) {
        if (this.value.limits[country.value] && country.value !== this.country) {
          this.isCountryDuplicate = true
          this.$emit('validationError', { hasError: true, message: 'Duplicate country detected' })
          return
        } else {
          this.isCountryDuplicate = false
          this.$emit('validationError', { hasError: false, message: '' })
        }
        if (!this.value.limits[country.value] && country.value !== this.country) {
          this.$emit('changeLimitCountry', { current: country.value, previous: this.country })
        }
      },

      recalculateValidation () {
        if (this.value.limits[this.country] && this.country !== 'default' && this.country !== '') {
          const countryCount = Object.keys(this.value.limits || {}).filter(key => key === this.country).length
          if (countryCount > 1) {
            this.isCountryDuplicate = true
            this.$emit('validationError', { hasError: true, message: 'Duplicate country detected' })
          } else {
            this.isCountryDuplicate = false
            this.$emit('validationError', { hasError: false, message: '' })
          }
        }
      },

      maxLvlToVSelectItems(lvl) {
        return [
          ...TEXT_LVLS,
          ...Array.from({length: lvl}).map((_, index) => index + 1)
        ]
      }
    }
  }
</script>
